module.exports = __webpack_public_path__ + "static/media/my-ham.5f6c09fd.svg";